exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".S2DMobileView-afe15d55{text-align:center;margin:0 30px 100px 30px}.S2DMobileView-afe15d55 .routePreview-354ba0a4{width:150px;height:150px;margin:30px 0;border-radius:50%}.S2DMobileView-afe15d55 .hasApp-7a344e7d{display:block;margin:45px 0 0 0}\n", ""]);

// Exports
exports.locals = {
	"S2DMobileView": "S2DMobileView-afe15d55",
	"routePreview": "routePreview-354ba0a4",
	"hasApp": "hasApp-7a344e7d"
};